var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 852 192",
    style: {
      enableBackground: "new 0 0 852 192"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Version-3_2_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Homepage_2_",
    transform: "translate(-898.000000, -1548.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-40_2_",
    transform: "translate(898.000000, 1548.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1_2_",
    className: "st0",
    points: "189.6,119.9 149.6,135 56.2,72.2 96.1,57  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-2_2_",
    className: "st0",
    points: "16.3,112.3 109.7,175.1 149.6,159.9 56.2,97.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3_2_",
    className: "st0",
    points: "136.1,17 96.1,32.1 189.6,94.9 229.5,79.8  "
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-39_2_",
    transform: "translate(0.000000, 0.098000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6_2_",
    transform: "translate(44.800000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-4_2_",
    className: "st0",
    d: "M220.8,82.3c-4.3-1.4-7.9-3.4-11-6.1l3.5-7.1c3.2,2.6,6.6,4.5,10.1,5.7 c3.5,1.2,7.3,1.7,11.7,1.7c4.9,0,8.7-0.9,11.4-2.8c2.7-1.8,4-4.4,4-7.8c0-2.9-1.2-5-3.7-6.4s-6.5-2.7-12-4 c-5.2-1.1-9.5-2.4-12.9-3.8s-6-3.4-7.9-5.8c-1.9-2.5-2.9-5.6-2.9-9.4c0-3.9,1-7.3,3-10.2c2-2.9,4.9-5.2,8.7-6.9 c3.7-1.7,8.1-2.5,13-2.5c4.6,0,9,0.7,13.1,2.1c4.1,1.4,7.4,3.4,10.1,6l-3.4,7.1c-3.1-2.5-6.2-4.4-9.4-5.6 c-3.2-1.2-6.6-1.8-10.2-1.8c-4.7,0-8.5,1-11.2,2.9c-2.7,2-4.1,4.7-4.1,8.2c0,3,1.2,5.3,3.6,6.8s6.2,2.9,11.4,4.2 c5.5,1.2,9.9,2.5,13.3,3.9c3.4,1.3,6.1,3.2,8.1,5.5c2,2.3,3,5.4,3,9.1c0,3.8-1,7.1-3,10c-2,2.9-4.9,5.1-8.7,6.6 c-3.8,1.6-8.3,2.3-13.4,2.3C229.8,84.3,225.1,83.7,220.8,82.3"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Fill-7_2_",
    className: "st0",
    d: "M340.6,72.6c2.2-2.7,3.3-6.8,3.3-12.1c0-5.2-1.1-9.3-3.4-12c-2.2-2.8-5.4-4.2-9.5-4.2 s-7.3,1.4-9.5,4.2c-2.2,2.8-3.4,6.8-3.4,12c0,5.3,1.1,9.3,3.3,12.1c2.2,2.7,5.4,4.1,9.6,4.1C335.2,76.8,338.4,75.4,340.6,72.6  M319.2,81.4c-3.4-1.9-6-4.7-7.9-8.3c-1.8-3.6-2.8-7.8-2.8-12.5c0-4.8,0.9-9,2.8-12.6c1.8-3.6,4.5-6.3,7.9-8.3 c3.4-1.9,7.3-2.9,11.8-2.9s8.4,1,11.8,2.9s6,4.7,7.9,8.3c1.8,3.6,2.8,7.8,2.8,12.6c0,4.7-0.9,8.9-2.8,12.5 c-1.8,3.6-4.5,6.3-7.9,8.3c-3.4,1.9-7.3,2.9-11.8,2.9S322.6,83.3,319.2,81.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-9_2_",
    className: "st0",
    d: "M369,81.4c-3.4-1.9-6-4.7-7.9-8.2c-1.8-3.5-2.8-7.7-2.8-12.4c0-4.7,1-8.9,2.9-12.5 s4.6-6.4,8-8.4c3.5-2,7.5-3,12.1-3c3.2,0,6.3,0.5,9.2,1.6c3,1.1,5.4,2.5,7.3,4.3l-2.9,6.7c-4.1-3.4-8.4-5.1-12.8-5.1 s-7.8,1.4-10.2,4.3c-2.5,2.8-3.7,6.8-3.7,12c0,5.1,1.2,9.1,3.7,11.8c2.4,2.8,5.9,4.2,10.3,4.2s8.7-1.7,12.8-5.1l2.9,6.8 c-2,1.8-4.5,3.2-7.5,4.3c-3,1-6.1,1.5-9.4,1.5C376.4,84.3,372.4,83.3,369,81.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-11_2_",
    className: "st0",
    d: "M406.2,83.6h9.5V37.9h-9.5V83.6z M405.5,27.3h10.9v-9.8h-10.9V27.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-13_2_",
    className: "st0",
    d: "M450.6,73.7c2.2-2.3,3.3-5.4,3.3-9v-2.4h-1.7c-4.9,0-8.6,0.2-11.2,0.7 c-2.6,0.4-4.5,1.2-5.6,2.2s-1.7,2.5-1.7,4.4c0,2.2,0.8,4,2.4,5.5s3.6,2.2,6.1,2.2C445.6,77.2,448.4,76.1,450.6,73.7 M458.6,41.4 c3,3.1,4.4,7.7,4.4,13.9v28.3h-9.1V76c-1.2,2.7-2.9,4.7-5.3,6.1c-2.3,1.4-5.1,2.1-8.2,2.1c-3,0-5.7-0.6-8.2-1.8 s-4.4-2.9-5.8-5.1c-1.4-2.2-2.1-4.6-2.1-7.3c0-3.3,0.9-5.9,2.6-7.8s4.6-3.3,8.5-4.1c4-0.8,9.4-1.2,16.3-1.2h2.2v-2.7 c0-3.5-0.7-6-2.2-7.6s-3.9-2.3-7.2-2.3c-5.2,0-10.4,1.6-15.5,4.8l-2.8-6.6c2.4-1.7,5.4-3,8.8-4.1c3.5-1,6.8-1.5,10-1.5 C451.1,36.8,455.6,38.3,458.6,41.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-14_2_",
    className: "st0",
    points: "471.5,83.6 480.9,83.6 480.9,17.6 471.5,17.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-15_2_",
    className: "st0",
    points: "575.6,17.6 583.2,17.6 583.2,83.6 574.5,83.6 574.6,35.9 555,73 548.4,73  528.7,36.3 528.8,83.6 520.1,83.6 520.1,17.6 527.8,17.6 551.8,63.3  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-16_2_",
    className: "st0",
    d: "M622.5,72.6c2.2-2.7,3.3-6.8,3.3-12.1c0-5.2-1.1-9.3-3.4-12c-2.2-2.8-5.4-4.2-9.5-4.2 s-7.3,1.4-9.5,4.2c-2.2,2.8-3.4,6.8-3.4,12c0,5.3,1.1,9.3,3.3,12.1c2.2,2.7,5.4,4.1,9.6,4.1C617.1,76.8,620.2,75.4,622.5,72.6  M601.1,81.4c-3.4-1.9-6-4.7-7.9-8.3c-1.8-3.6-2.8-7.8-2.8-12.5c0-4.8,0.9-9,2.8-12.6c1.8-3.6,4.5-6.3,7.9-8.3 c3.4-1.9,7.3-2.9,11.8-2.9s8.4,1,11.8,2.9c3.4,1.9,6,4.7,7.9,8.3c1.8,3.6,2.8,7.8,2.8,12.6c0,4.7-0.9,8.9-2.8,12.5 c-1.8,3.6-4.5,6.3-7.9,8.3c-3.4,1.9-7.3,2.9-11.8,2.9C608.5,84.3,604.5,83.3,601.1,81.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-17_2_",
    className: "st0",
    d: "M674.7,72.5c2.3-2.9,3.4-6.9,3.4-12.1c0-5.1-1.1-9.1-3.4-11.8c-2.2-2.8-5.4-4.2-9.5-4.2 s-7.3,1.4-9.5,4.2c-2.2,2.8-3.3,6.8-3.3,12s1.1,9.2,3.3,12c2.2,2.8,5.4,4.2,9.5,4.2S672.4,75.3,674.7,72.5 M678,39.7 c3.1,1.9,5.4,4.7,7.2,8.2c1.7,3.6,2.6,7.7,2.6,12.4c0,4.7-0.9,8.8-2.6,12.4c-1.7,3.6-4.1,6.4-7.2,8.4c-3.1,2-6.6,3-10.5,3 c-3.4,0-6.5-0.7-9.1-2.2s-4.6-3.6-6-6.3v7.9h-9.5v-66h9.5v27.8c1.4-2.7,3.4-4.9,6-6.4s5.6-2.2,9.1-2.2 C671.4,36.8,675,37.8,678,39.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-18_2_",
    className: "st0",
    d: "M695.2,83.6h9.5V37.9h-9.5V83.6z M694.6,27.3h10.9v-9.8h-10.9V27.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-19_2_",
    className: "st0",
    points: "716.4,83.6 725.9,83.6 725.9,17.6 716.4,17.6  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-20_2_",
    className: "st0",
    d: "M737.6,83.6h9.5V37.9h-9.5V83.6z M736.9,27.3h10.9v-9.8h-10.9V27.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-21_2_",
    className: "st0",
    d: "M786.1,76.7l-0.5,7.2c-1.6,0.2-3.2,0.4-4.9,0.4c-5.9,0-10.3-1.5-13.2-4.4 s-4.4-7.1-4.4-12.6V45.2h-8.9v-7.3h8.9V24.2h9.5V38H785v7.3h-12.5V67c0,6.7,3.1,10,9.3,10C783.2,77,784.7,76.9,786.1,76.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-22_2_",
    className: "st0",
    points: "826.2,38 835.8,38 808.5,100.4 799,100.4 807,82.5 787.8,38 797.7,38 811.9,72.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-23_2_",
    className: "st0",
    points: "301.7,108.3 310.8,108.3 310.8,174.3 303.4,174.3 265.6,124.5 265.6,174.3  256.6,174.3 256.6,108.3 263.9,108.3 301.7,158.2  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-24_2_",
    className: "st0",
    d: "M329.9,137.9c-2.2,2.3-3.4,5.5-3.9,9.8h24.1c-0.2-4.2-1.3-7.5-3.2-9.8 c-2-2.3-4.7-3.4-8.3-3.4C334.9,134.5,332,135.6,329.9,137.9L329.9,137.9z M358.2,153.1h-32.3c0.7,9.7,5.5,14.5,14.4,14.5 c5.2,0,10-1.7,14.2-5.1l2.9,6.6c-2.1,1.8-4.7,3.2-7.9,4.3c-3.1,1.1-6.3,1.6-9.5,1.6c-7.3,0-13.1-2.1-17.3-6.3 c-4.2-4.2-6.3-10-6.3-17.3c0-4.7,0.9-8.8,2.8-12.4c1.8-3.6,4.4-6.4,7.8-8.4c3.3-2,7.1-3,11.4-3c6.2,0,11,2,14.6,6 c3.5,4,5.3,9.5,5.3,16.6v2.9H358.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-25_2_",
    className: "st0",
    d: "M392.4,167.4l-0.5,7.2c-1.6,0.2-3.2,0.4-4.9,0.4c-5.9,0-10.3-1.5-13.2-4.4 c-2.9-2.9-4.4-7.1-4.4-12.6v-22.1h-8.9v-7.2h8.9v-13.8h9.5v13.8h12.5v7.3h-12.5v21.7c0,6.7,3.1,10,9.3,10 C389.7,167.7,391.1,167.6,392.4,167.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-26_2_",
    className: "st0",
    points: "462.2,128.7 471.5,128.7 454,174.3 445.5,174.3 433.4,141.7 421.4,174.3  412.7,174.3 395.3,128.7 405.2,128.7 417.5,163 430,128.7 437.4,128.7 449.8,163.2  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-27_2_",
    className: "st0",
    d: "M504,163.4c2.2-2.7,3.3-6.8,3.3-12.1c0-5.2-1.1-9.3-3.4-12c-2.2-2.8-5.4-4.2-9.5-4.2 c-4.1,0-7.3,1.4-9.5,4.2s-3.4,6.8-3.4,12c0,5.3,1.1,9.3,3.3,12.1c2.2,2.7,5.4,4.1,9.6,4.1C498.6,167.5,501.8,166.1,504,163.4  M482.6,172.1c-3.4-1.9-6-4.7-7.9-8.3c-1.8-3.6-2.8-7.8-2.8-12.5c0-4.8,0.9-9,2.8-12.6c1.8-3.6,4.5-6.3,7.9-8.3 c3.4-1.9,7.3-2.9,11.8-2.9c4.5,0,8.4,1,11.8,2.9s6,4.7,7.9,8.3c1.8,3.6,2.8,7.8,2.8,12.6c0,4.7-0.9,8.9-2.8,12.5 c-1.8,3.6-4.5,6.4-7.9,8.3c-3.4,1.9-7.3,2.9-11.8,2.9C489.9,175,486,174,482.6,172.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-28_2_",
    className: "st0",
    d: "M550.7,135.5l-5.7,0.6c-4.5,0.4-7.7,1.8-9.7,4.1s-3,5.2-3,8.8v25.4h-9.5v-45.7h9.2v8 c2.4-5.4,7.4-8.3,14.9-8.9l3.1-0.2L550.7,135.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-29_2_",
    className: "st0",
    points: "598.7,174.3 586.7,174.3 565.1,152.8 565.1,174.3 555.7,174.3 555.7,108.3  565.1,108.3 565.1,149.2 585.2,128.7 596.9,128.7 575.2,150.7  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-30_2_",
    className: "st0",
    d: "M714.5,149.4v18.7h-1.6v-3.5c-0.6,1.2-1.5,2.1-2.7,2.8s-2.5,1-4,1c-2.3,0-4-0.6-5.1-1.8 c-1.2-1.2-1.7-3-1.7-5.3v-11.8h1.7v11.7c0,2,0.4,3.4,1.2,4.3c0.8,0.9,2.1,1.4,3.9,1.4c2,0,3.6-0.6,4.8-1.8s1.8-2.9,1.8-4.9 v-10.7L714.5,149.4L714.5,149.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-31_2_",
    className: "st0",
    d: "M731.2,150.1c1.3,0.8,2.3,1.9,3.1,3.4c0.7,1.5,1.1,3.2,1.1,5.1c0,1.9-0.4,3.6-1.1,5.1 c-0.7,1.5-1.7,2.6-3.1,3.4c-1.3,0.8-2.8,1.2-4.5,1.2c-1.6,0-3-0.3-4.2-1s-2-1.7-2.6-3V175h-1.7v-25.6h1.7v3.5 c0.6-1.3,1.5-2.3,2.6-3c1.2-0.7,2.6-1,4.2-1C728.4,148.9,729.9,149.3,731.2,150.1 M731.7,164.6c1.2-1.4,1.8-3.4,1.8-6 s-0.6-4.6-1.8-6s-2.9-2.2-5-2.2c-2.2,0-3.9,0.7-5.1,2.1c-1.2,1.4-1.8,3.4-1.8,6s0.6,4.6,1.8,6s2.9,2.1,5,2.1 C728.8,166.7,730.5,166,731.7,164.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-32_2_",
    className: "st0",
    d: "M761.4,168.1h-4.6l-4.8-8.7c-0.5-0.9-1.2-1.6-1.9-1.9c-0.7-0.4-1.7-0.6-2.9-0.6h-4.7v11.2 h-4.1v-27.2h12.1c3.1,0,5.5,0.7,7.2,2c1.6,1.3,2.5,3.3,2.5,5.9c0,2.1-0.6,3.8-1.8,5.1s-3,2.2-5.2,2.5c1.4,0.4,2.5,1.4,3.5,3 L761.4,168.1z M749.9,153.6c2.1,0,3.6-0.4,4.6-1.2s1.5-2,1.5-3.6s-0.5-2.9-1.5-3.6c-1-0.8-2.5-1.1-4.7-1.1h-7.5v9.6L749.9,153.6 L749.9,153.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-33_2_",
    className: "st0",
    d: "M778.8,159.3h-13.9c0.3,4,2.4,6,6.2,6c2.3,0,4.3-0.7,6.1-2.1l1.2,2.7 c-0.9,0.7-2,1.3-3.4,1.8c-1.3,0.4-2.7,0.7-4.1,0.7c-3.1,0-5.6-0.9-7.4-2.6c-1.8-1.7-2.7-4.1-2.7-7.1c0-1.9,0.4-3.6,1.2-5.1 s1.9-2.7,3.3-3.5c1.4-0.8,3.1-1.2,4.9-1.2c2.7,0,4.7,0.8,6.3,2.5c1.5,1.6,2.3,3.9,2.3,6.8L778.8,159.3L778.8,159.3z M766.6,153 c-0.9,0.9-1.5,2.3-1.7,4h10.3c-0.1-1.8-0.5-3.1-1.4-4c-0.8-0.9-2-1.4-3.6-1.4C768.8,151.6,767.6,152.1,766.6,153L766.6,153z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-34_2_",
    className: "st0",
    d: "M795.2,150.6c1.3,1.3,1.9,3.2,1.9,5.8v11.7h-3.9V165c-0.5,1.1-1.3,1.9-2.3,2.5 s-2.2,0.9-3.5,0.9s-2.5-0.3-3.5-0.8c-1.1-0.5-1.9-1.2-2.5-2.1c-0.6-0.9-0.9-1.9-0.9-3c0-1.4,0.4-2.4,1.1-3.2 c0.7-0.8,2-1.3,3.7-1.7c1.7-0.3,4-0.5,7-0.5h0.9V156c0-1.4-0.3-2.5-0.9-3.1c-0.6-0.6-1.7-1-3.1-1c-2.2,0-4.4,0.7-6.7,2l-1.2-2.7 c1-0.7,2.3-1.3,3.8-1.7s2.9-0.6,4.3-0.6C792.1,148.7,794,149.4,795.2,150.6 M791.9,164c0.9-1,1.4-2.2,1.4-3.7v-1h-0.7 c-2.1,0-3.7,0.1-4.8,0.3s-1.9,0.5-2.4,0.9s-0.7,1-0.7,1.8c0,0.9,0.3,1.7,1,2.3s1.6,0.9,2.6,0.9 C789.7,165.4,790.9,164.9,791.9,164"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-35_2_",
    className: "st0",
    d: "M803.8,167.1c-1.5-0.8-2.6-1.9-3.4-3.4c-0.8-1.5-1.2-3.2-1.2-5.1c0-2,0.4-3.7,1.2-5.2 s2-2.7,3.5-3.5s3.2-1.2,5.2-1.2c1.4,0,2.7,0.2,4,0.7c1.3,0.4,2.3,1,3.1,1.8l-1.2,2.8c-1.8-1.4-3.6-2.1-5.5-2.1s-3.3,0.6-4.4,1.8 c-1.1,1.2-1.6,2.8-1.6,5c0,2.1,0.5,3.7,1.6,4.9c1,1.1,2.5,1.7,4.4,1.7s3.7-0.7,5.5-2.1l1.2,2.8c-0.9,0.7-1.9,1.3-3.2,1.8 c-1.3,0.4-2.6,0.6-4,0.6C807,168.3,805.2,167.9,803.8,167.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-36_2_",
    className: "st0",
    d: "M835.8,156.4v11.7h-4.1v-11.5c0-1.6-0.3-2.8-1-3.5s-1.7-1.1-3.1-1.1c-1.6,0-3,0.5-3.9,1.5 c-1,1-1.5,2.3-1.5,3.9v10.7h-4.1v-27.2h4.1v11.2c0.7-1.1,1.6-1.9,2.7-2.5c1.1-0.6,2.4-0.9,3.8-0.9 C833.4,148.7,835.8,151.3,835.8,156.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-37_2_",
    className: "st0",
    d: "M666,164.2c1.1-1.4,1.7-3.4,1.7-6c0-2.5-0.6-4.4-1.7-5.8c-1.1-1.4-2.7-2.1-4.8-2.1 s-3.6,0.7-4.7,2.1c-1.1,1.4-1.7,3.4-1.7,5.9c0,2.6,0.6,4.5,1.7,5.9c1.1,1.4,2.7,2.1,4.8,2.1C663.2,166.3,664.8,165.6,666,164.2  M665.5,149.9c1.2,0.8,2.2,1.9,2.9,3.3c0.7,1.4,1,3.1,1,5s-0.3,3.6-1,5.1s-1.6,2.6-2.9,3.4c-1.2,0.8-2.7,1.2-4.3,1.2 c-1.5,0-2.9-0.3-4-1s-1.9-1.7-2.5-3v3.7h-1.6v-26.8h1.6v11.9c0.6-1.3,1.4-2.2,2.5-2.9s2.4-1,4-1S664.2,149.2,665.5,149.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-38_2_",
    className: "st0",
    points: "685.6,149.2 687.2,149.2 676.5,174.4 674.9,174.4 677.7,167.8 669.8,149.2  671.5,149.2 678.5,166.2  "
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9ea307c00750cfeb2aacbfadf427004d.svg";
export { ForwardRef as ReactComponent };